import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { Option } from '../../../types/content';
import { errorClass, FieldTone, inputClass, labelClass } from '../../../utils/fieldStyles';
interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder: string;
  required?: boolean;
  error?: string;
  tone?: FieldTone;
}
export function SelectField({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  required,
  error,
  tone = 'light'
}: SelectFieldProps) {
  return <div data-id="element-57" data-mp="33sgp2zg7iqyq">
      <label htmlFor={id} className={labelClass(tone)} data-id="element-58" data-mp="3hletfbamntef">
        {label}
        {required && <span aria-hidden="true" data-id="element-59" data-mp="3hnixpucfuuf8"> *</span>}
      </label>
      <div className="relative" data-id="element-60" data-mp="3cnwff6hr6nzk">
        <select id={id} name={id} value={value} required={required} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} onChange={event => onChange(event.target.value)} className={`h-12 appearance-none pr-10 ${inputClass(tone, Boolean(error))} ${value ? '' : tone === 'dark' ? 'text-white/40' : 'text-afb-muted/80'}`} data-id="element-61" data-mp="3coxt7iq5lokz">
          <option value="" disabled data-id="element-62" data-mp="ld8u7j4e5p4a">
            {placeholder}
          </option>
          {options.map(option => <option key={option.value} value={option.value} className="text-afb-ink" data-id="element-63" data-mp="qeejt82r8w9l">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon aria-hidden="true" className={`pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 ${tone === 'dark' ? 'text-white/50' : 'text-afb-muted'}`} data-id="element-64" data-mp="10a9b0rl1nznz" />
      </div>
      {error && <p id={`${id}-error`} className={errorClass(tone)} data-id="element-65" data-mp="1e2xvlxl0jr6f">
          {error}
        </p>}
    </div>;
}